import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { useProjectState } from "../../../context/stateContext";
import appActions from "../../../redux/getOrganizationAndRestaurant/actions";
import PageHeader from "../../../components/Common/PageHeader/PageHeader";
import WaitersInfoActions from "../../../components/User/WaitersInfoComponents/WaitersInfoActions";
import WaiterInfoTable from "../../../components/User/WaitersInfoComponents/WaiterInfoTable";

const { getRestaurants } = appActions;

const WaitersInfo = () => {
  const { selectedOrganization } = useProjectState();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRestaurants());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization]);

  return (
    <>
      <PageHeader text="Справка по сервитьори" date={true} />
      <WaitersInfoActions />
      <WaiterInfoTable />
    </>
  );
};

export default WaitersInfo;
